import { createGlovoError, extractErrorMeta } from './helpers/create-glovo-error';
import { maskedObject } from './helpers/masked-object';
import { initIntegrations, setErrorStackTrace, startErrorEmitters, validateEmitters, validateEmittersPlugins, validateEventRecorder, validateIntegrations, validateStackTraceLimit, } from './utils';
const validateOptions = (options) => {
    const { errorEmitterPlugins = [], integrations = [], recorder, stackTraceLimit } = options;
    validateEmittersPlugins(errorEmitterPlugins);
    validateIntegrations(integrations);
    validateEventRecorder(recorder);
    validateStackTraceLimit(stackTraceLimit);
};
export function makeRumInstance() {
    let initialised = false;
    let _integrations = [];
    let _recorder;
    return {
        init(options) {
            if (initialised) {
                return;
            }
            validateOptions(options);
            const { errorEmitterPlugins: plugins = [], integrations = [], recorder, stackTraceLimit, } = options;
            const emitters = plugins.map((plugin) => plugin(this));
            validateEmitters(emitters);
            _recorder = recorder;
            _integrations = recorder ? [recorder, ...integrations.slice()] : integrations.slice();
            initIntegrations(_integrations);
            startErrorEmitters(emitters);
            setErrorStackTrace(stackTraceLimit);
            initialised = true;
        },
        addError(exception, context = {}) {
            const error = createGlovoError(exception);
            _integrations.forEach((integration) => integration.addError(error, maskedObject({ ...extractErrorMeta(error), ...context })));
        },
        setUser(user) {
            _integrations.forEach((integration) => integration.setUser(user));
        },
        clearUser() {
            _integrations.forEach((integration) => integration.clearUser());
        },
        addAction(actionName, context = {}) {
            _integrations.forEach((integration) => integration.addAction(actionName, maskedObject(context)));
        },
        setContext(key, value) {
            _integrations.forEach((integration) => integration.setContext(key, maskedObject(value)));
        },
        addIntegration(integration) {
            if (initialised) {
                integration.init();
            }
            _recorder?.replay(integration);
            _integrations.push(integration);
        },
        setRouteName(name) {
            _integrations.forEach((integration) => integration.setRouteName(name));
        },
        addTiming(name, time) {
            _integrations.forEach((integration) => integration.addTiming(name, time));
        },
        addPlugin(plugin) {
            const emitter = plugin(this);
            validateEmitters([emitter]);
            startErrorEmitters([emitter]);
        },
    };
}
//# sourceMappingURL=make-rum-instance.js.map